<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 9.5L12 15L19 9.5M22.5 19.5H3.5C2.4 19.5 1.5 18.6 1.5 17.5V4.5H20.5C21.6 4.5 22.5 5.4 22.5 6.5V19.5Z"
      class="stroke-current"
    />
  </svg>
</template>
